<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="pt-4">{{ createOrUpdate }} dike schematisation</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <div v-if="relatedItem">
          <div v-if="stabSchematisationStageItemsDone.length">
            <v-text-field
              prepend-inner-icon="mdi-link-variant"
              :model-value="relatedItem.name"
              readonly
              color="primary"
              filled
            ></v-text-field>
            <v-select
              color="primary"
              :loading="false"
              :items="stabSchematisationStageItemsDone"
              v-model="selectedStabSchematisationStage"
              item-value="id"
              filled
              label="Select from which stage you would like to link the schematisation"
            >
              <template v-slot:selection="{ item }">
                {{ item.raw.stage_configuration?.number }} |
                {{ item.raw.stage_configuration?.name }}
              </template>
              <template v-slot:item="{ item }">
                <v-list-item>
                  {{ item.raw.stage_configuration?.number }} |
                  {{ item.raw.stage_configuration?.name }}
                </v-list-item>
              </template>
            </v-select>
          </div>
          <v-alert type="error" variant="outlined" density="compact" class="mb-2" v-else>
            You cannot link a new schematisation of the base schematisation has 0 done stages.
          </v-alert>
        </div>
        <FormRHDHV ref="form" :url="url" :model="model" :formOrder="order" :dialog="dialog" />
        <CustomizeOption
          :items="yearItems"
          v-model="year"
          prepend-inner-icon="mdi-calendar-multiple"
          item-title="year"
          item-text="id"
          label="Select year"
          :readonly="relatedItem"
        />
        <CustomizeOption
          v-model="stageConfigurationRevision"
          :items="getRevisionSet(REVISION_KEY.STAGE_CONFIGURATION)"
          prepend-inner-icon="mdi-table"
          item-title="name"
          item-text="id"
          label="Select stage configuration revision"
          :readonly="relatedItem"
        />
        <CustomizeOption
          v-model="soilTypeRevision"
          prepend-inner-icon="mdi-landslide"
          :items="getRevisionSet(REVISION_KEY.SOIL_TYPE)"
          item-title="name"
          item-text="id"
          label="Select soil type revision"
          :readonly="relatedItem"
        />
        <CustomizeOption
          v-model="waterLineRuleRevision"
          prepend-inner-icon="mdi-window-shutter-cog"
          :items="getRevisionSet(REVISION_KEY.WATER_LINE_RULE)"
          label="Select water line rule revision"
          item-title="name"
          item-text="id"
          :readonly="relatedItem"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="writeLoading"
          :disabled="relatedItem && !stabSchematisationStageItemsDone.length"
          color="primary"
          text
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FormRHDHV from '@/components/form/FormRHDHV.vue'
import { REVISION_KEY } from '@/components/constant'
import CustomizeOption from '@/components/common/CustomizeOption.vue'

export default {
  name: 'StabSchematisationDialog',
  components: { CustomizeOption, FormRHDHV },
  data: () => ({
    url: 'stab_schematisations',
    model: {
      id: '',
      name: '',
      year: '',
      dike_profile: '',
      user: ''
    },
    year: null,
    soilTypeRevision: null,
    stageConfigurationRevision: null,
    waterLineRuleRevision: null,
    selectedStabSchematisationStage: null,
    order: ['name']
  }),
  computed: {
    REVISION_KEY() {
      return REVISION_KEY
    },
    ...mapState('years', {
      yearItems: (state) => state.items
    }),
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapState('stabSchematisation', {
      currentItem: (state) => state.currentItem,
      dialog: (state) => state.dialog,
      items: (state) => state.items,
      writeLoading: (state) => state.writeLoading
    }),
    ...mapState('stabSchematisationStage', {
      stabSchematisationStageItems: (state) => state.items
    }),
    ...mapState('users', {
      currentUser: (state) => state.currentUser
    }),
    ...mapGetters('project', {
      selectedYear: 'selectedYear',
      parameterSetName: 'parameterSetName',
      selectedRevision: 'selectedRevision',
      selectedSoilTypeRevision: 'selectedSoilTypeRevision'
    }),
    stabSchematisationStageItemsDone() {
      return this.stabSchematisationStageItems.filter((item) => item.done)
    },
    relatedItem() {
      return this.currentItem
        ? this.items.find((item) => item.id === this.currentItem.relates_to)
        : null
    },
    createOrUpdate() {
      if (this.currentItem && this.currentItem.id) {
        return 'Update'
      } else {
        return 'Create'
      }
    }
  },
  watch: {
    stabSchematisationStageItemsDone() {
      if (this.relatedItem && this.stabSchematisationStageItemsDone.length) {
        this.selectedStabSchematisationStage = this.stabSchematisationStageItemsDone[0].id
      }
    },
    dialog(newValue) {
      if (newValue) {
        this.mapObj()
      }
      // Required otherwise the form will throw validation errors
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async currentItem() {
      if (this.relatedItem) {
        await this.fetchStabSchematisationStageItems(this.relatedItem.id)
      }
    }
  },
  methods: {
    ...mapActions('stabSchematisation', {
      toggleDialog: 'toggleDialog',
      createItem: 'createItem',
      setCurrentItem: 'setCurrentItem'
    }),
    ...mapActions('stabSchematisationStage', {
      fetchStabSchematisationStageItems: 'fetchItems'
    }),
    mapObj(newValue) {
      if (newValue && this.currentItem) {
        let keys = Object.keys(this.model)
        keys.forEach((key) => (this.model[key] = this.currentItem[key]))
      }
    },
    getRevisionSet(parameter) {
      const parameterSetName = this.parameterSetName(parameter)
      return this.currentProject[parameterSetName]
    },
    close() {
      this.$refs.form.resetValidation()
      this.toggleDialog()
      this.$refs.form.clearModel()
      // this.setCurrentItem(null)
    },
    async save() {
      let is_valid = this.$refs.form.save()
      if (is_valid) {
        this.model.soil_type_revision = this.soilTypeRevision.id
        this.model.stage_configuration_revision = this.stageConfigurationRevision.id
        this.model.water_line_rule_revision = this.waterLineRuleRevision.id
        this.model.year = this.year.id
        this.model.dike_profile = this.currentItem.dike_profile
        this.model.user = this.currentUser.id
        if (this.relatedItem) {
          this.model.stab_schematisation_stage = this.selectedStabSchematisationStage
        }
        await this.createItem(this.model)
        this.close()
      } else {
        console.log('Is not valid')
      }
    }
  },
  async mounted() {
    if (this.relatedItem) {
      await this.fetchStabSchematisationStageItems(this.relatedItem.id)
    }
    this.year = this.selectedYear
    this.soilTypeRevision = this.selectedRevision(REVISION_KEY.SOIL_TYPE)
    this.stageConfigurationRevision = this.selectedRevision(REVISION_KEY.STAGE_CONFIGURATION)
    this.waterLineRuleRevision = this.selectedRevision(REVISION_KEY.WATER_LINE_RULE)
  }
}
</script>
